import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcabserviceinpune() {



  const cardData =
  {
    keyword: ' Outstation Cab Service in Pune',
    heading: 'Sai Trupti Cabs: Outstation Cab Service in Pune',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable out-station cab services in Pune, designed to make your long-distance journeys smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every ride is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving throughout your route. With transparent one-way or round-trip fares, flexible booking options, and 24×7 customer support, Sai Trupti Cabs makes your out-station travel from Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune Outstation with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala, just 65 km from Pune, is a lush green hill station nestled in the Sahyadri ranges. Famous for its misty mountains, cascading waterfalls, and the sweet aroma of chikki in every corner, it’s the most popular weekend escape for Punekars. Tourists love visiting Tiger’s Leap, Bhushi Dam, and Lion’s Point for breathtaking valley views. The drive from Pune to Lonavala through tunnels and ghats is itself a scenic delight. Whether you’re seeking monsoon treks or cozy evenings by the fog, Lonavala offers pure mountain magic and rejuvenation."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, located 120 km from Pune, is a high-altitude paradise blanketed by evergreen forests, strawberry farms, and endless viewpoints. Arthur’s Seat, Elephant’s Head, and Wilson Point offer mesmerizing views of the Western Ghats. Venna Lake invites you for peaceful boating while Mapro Garden tempts you with fresh fruit crushes and chocolates. The cool mountain breeze and British-era charm make Mahabaleshwar a timeless retreat for couples and families alike. From sunrise to sunset, the town radiates calm, romance, and nature’s finest hues."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, India’s first planned hill city, lies 60 km from Pune and blends European elegance with natural tranquility. Its pastel-colored buildings, cobblestone streets, and waterfront cafés give it a Mediterranean feel. Built along Warasgaon Lake, Lavasa offers kayaking, jet skiing, cycling, and lakeside walks under drifting clouds. The Lakeside Promenade is perfect for capturing sunset reflections and enjoying local Goan cuisine. Whether you visit for leisure or photography, Lavasa enchants visitors with its modern charm and serene mountain vibes."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani, meaning ‘land of five hills,’ is a serene plateau town 100 km from Pune known for its panoramic views and colonial-era charm. The Table Land, Asia’s second-largest volcanic plateau, offers sweeping sights of valleys and sunsets. Strawberry farms, paragliding, and horseback rides add color to the experience. Parsi Point and Sydney Point are ideal spots to soak in the beauty of the Krishna River. The cool climate, peaceful roads, and old-world charm make Panchgani a refreshing getaway for travelers seeking relaxation and fresh air."
  },
  {
    "title": "Matheran",
    "description": "Matheran, around 120 km from Pune, is India’s smallest hill station — and uniquely, completely vehicle-free. Visitors either hike up or take the narrow-gauge toy train through forested slopes. The red-soil paths, British-era bungalows, and over 30 viewpoints including Panorama Point and Echo Point make it a nature lover’s haven. The peaceful silence broken only by birds and wind offers a rare escape from city noise. Horse rides, old cottages, and misty hills give Matheran its quaint, timeless appeal."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, located about 140 km from Pune, is the coastal gem of Maharashtra known for its pristine beaches, historic forts, and relaxed seaside vibe. From sun-soaked Kashid Beach to the picturesque Kolaba Fort accessible during low tide, every corner blends heritage and leisure. The air carries the fragrance of the sea and local Konkani seafood delicacies. Tourists love beach walks, water sports, and ferry rides. Alibaug’s tranquil coastline, coconut groves, and breezy charm make it a perfect outstation destination for weekend rejuvenation."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, about 110 km from Pune, is both a sacred pilgrimage site and a nature reserve. Home to one of the 12 Jyotirlingas of Lord Shiva, the temple rests amid dense forests of the Western Ghats. The Bhimashankar Wildlife Sanctuary surrounding it shelters the rare Indian Giant Squirrel and countless bird species. The trek through waterfalls and misty trails is equally exhilarating for adventurers. Whether you visit for faith or for forest serenity, Bhimashankar rejuvenates both soul and spirit."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is a unique blend of spirituality and sophistication — home to the sacred Godavari River and India’s finest vineyards. Trimbakeshwar Temple attracts devotees, while Sula Vineyards offers wine tastings among lush green estates. The city hosts the Kumbh Mela every 12 years, drawing millions of pilgrims. Nashik’s calm ghats, scenic hills, and luxurious resorts make it perfect for both religious journeys and romantic vineyard getaways. It’s a destination that nourishes both faith and leisure."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, around 185 km from Pune, is a sacred town synonymous with the life and teachings of Shri Sai Baba. Devotees from all over India visit the Sai Baba Samadhi Temple to seek blessings and peace. The spiritual energy here is palpable, especially during aarti when chants fill the air with devotion. Beyond religion, Shirdi’s clean, organized environment and nearby attractions like Shani Shingnapur make it a fulfilling day-trip from Pune. Every visitor leaves with serenity and renewed faith."
  },
  {
    "title": "Khandala",
    "description": "Khandala, located just beyond Lonavala, is a romantic hill station famous for its mist-covered cliffs and scenic viewpoints like Duke’s Nose and Rajmachi Point. The lush valleys and seasonal waterfalls create a postcard-perfect setting, especially during monsoon. The drive from Pune to Khandala along the Mumbai–Pune Expressway offers breathtaking panoramas of tunnels, mountains, and clouds. Ideal for trekking, photography, and long drives, Khandala offers a peaceful blend of adventure and tranquility — the quintessential escape close to Pune."
  }
],



"services": [
    {
      "name": "Outstation Cab Service in Pune",
      "description": "Book the best Outstation Cab Service in Pune for a smooth and safe intercity journey. Whether you’re planning a weekend getaway, business trip, or family vacation, we offer reliable and comfortable cabs with professional drivers. Choose from a wide range of vehicles including Sedans, SUVs, Ertiga, and Innova. Enjoy doorstep pickup, affordable pricing, 24x7 service, and transparent billing. We ensure every ride from Pune to any destination is comfortable, on-time, and stress-free."
    },
    {
      "name": "Pune Outstation Taxi Service",
      "description": "Our Pune Outstation Taxi Service is perfect for travelers looking for comfortable long-distance rides. We provide AC and Non-AC taxis for trips to destinations like Mumbai, Mahabaleshwar, Shirdi, Nashik, and Goa. All our vehicles are well-maintained and driven by courteous chauffeurs. With punctual pickups, GPS-enabled cars, and 24-hour support, we guarantee a safe and pleasant experience for family, corporate, and personal travel."
    },
    {
      "name": "Pune Outstation Car Hire",
      "description": "Hire a car in Pune for your next outstation journey at unbeatable rates. Our Pune Outstation Car Hire service includes multiple car options like Sedans, SUVs, and premium vehicles. We offer flexible rental packages for one-way, round-trip, and multi-city travel. Every car is sanitized, equipped with essential amenities, and driven by experienced drivers who prioritize your safety and comfort."
    },
    {
      "name": "AC Outstation Cab Pune",
      "description": "Travel in complete comfort with our AC Outstation Cab Service in Pune. Designed for travelers who value convenience, our air-conditioned cars ensure a relaxed and enjoyable journey. Perfect for families, executives, and tourists heading to destinations like Lonavala, Kolhapur, or Nashik. Our AC cabs are available round-the-clock with easy online booking and transparent fare structure."
    },
    {
      "name": "Non AC Outstation Cab Pune",
      "description": "For budget-conscious travelers, our Non-AC Outstation Cab Pune service offers the best combination of affordability and reliability. Travel comfortably with our well-maintained cars and skilled drivers. Perfect for students, small families, or groups looking for economical intercity transportation without compromising on safety or punctuality."
    },
    {
      "name": "Luxury Outstation Cab Pune",
      "description": "Travel in style with our Luxury Outstation Cab Service in Pune. Choose from premium cars like Innova Crysta, Fortuner, and Sedans for your outstation trips. Ideal for business executives, VIP guests, and wedding functions. Our luxury fleet provides plush interiors, AC comfort, and professional chauffeurs to ensure a premium travel experience."
    },
    {
      "name": "Innova Outstation Cab Pune",
      "description": "Book an Innova Outstation Cab in Pune for spacious and comfortable long-distance travel. Our 7-seater Innovas are ideal for family trips, group tours, and corporate outings. With flexible booking options, well-trained drivers, and clean vehicles, we make intercity travel effortless and enjoyable. Popular routes include Pune to Mumbai, Pune to Goa, and Pune to Shirdi."
    },
    {
      "name": "Ertiga Outstation Cab Pune",
      "description": "Hire an Ertiga Outstation Cab from Pune for reliable and affordable travel. Perfect for small families or groups, our Ertiga cabs offer ample space, comfort, and AC/Non-AC options. Our trained chauffeurs ensure a smooth and safe ride across all major outstation routes. Whether for business or leisure, we make every journey pleasant and hassle-free."
    },
    {
      "name": "Affordable Outstation Cab Pune",
      "description": "Looking for an affordable yet dependable cab service? Our Affordable Outstation Cab Pune offers competitive fares, flexible booking options, and excellent service. Choose from multiple vehicle categories and enjoy a comfortable journey with transparent billing, no hidden charges, and professional drivers. Ideal for long-distance family or group travel."
    },
    {
      "name": "Pune One Way Outstation Cab",
      "description": "Book a Pune One Way Outstation Cab and pay only for the distance you travel. This service is ideal for travelers heading to nearby cities without needing a return trip. Our one-way taxis are available 24/7 for destinations like Mumbai, Kolhapur, Solapur, and Nashik. Enjoy flexible pickups, comfortable rides, and affordable fares."
    },
    {
      "name": "Pune Drop Cab Service",
      "description": "Our Pune Drop Cab Service offers convenient one-way intercity travel. Get dropped safely at your destination with punctual drivers and clean, comfortable vehicles. Ideal for airport transfers, business meetings, or family travel. Enjoy affordable rates, timely service, and easy online booking for all your drop cab needs."
    },
    {
      "name": "Corporate Outstation Cab Pune",
      "description": "We specialize in Corporate Outstation Cab Services from Pune, offering premium travel solutions for business executives and employees. Our service ensures punctuality, comfort, and convenience with a fleet of luxury cars and SUVs. We provide invoice-ready billing, 24x7 support, and custom travel plans for meetings, conferences, or events."
    },
    {
      "name": "Wedding Outstation Cab Pune",
      "description": "Make your wedding travel arrangements hassle-free with our Wedding Outstation Cab Pune. We provide a range of luxury and standard vehicles for guests and family members. Enjoy on-time pickups, professional chauffeurs, and comfortable rides to and from wedding venues across Maharashtra. Perfect for destination weddings and event transfers."
    },
    {
      "name": "Online Outstation Cab Pune",
      "description": "Book your outstation cab in Pune instantly through our Online Outstation Cab Booking platform. Choose your car, select your destination, and confirm your booking in just a few clicks. We offer secure payment options, instant confirmations, and 24/7 customer support to make your travel booking seamless and convenient."
    },
    {
      "name": "Best Outstation Cab Service Pune",
      "description": "Experience the Best Outstation Cab Service in Pune with our reliable and customer-focused transportation. We offer flexible travel packages, comfortable vehicles, and experienced drivers for all intercity routes. Whether it’s a short trip to Lonavala or a long drive to Goa, we ensure your journey is safe, smooth, and enjoyable at every step."
    }
  ],
  "tableData": [
    ["Outstation Cab Service in Pune", "Pune Outstation Taxi Service"],
    ["Pune Outstation Car Hire", "AC Outstation Cab Pune"],
    ["Non AC Outstation Cab Pune", "Luxury Outstation Cab Pune"],
    ["Innova Outstation Cab Pune", "Ertiga Outstation Cab Pune"],
    ["Affordable Outstation Cab Pune", "Pune One Way Outstation Cab"],
    ["Pune Drop Cab Service", "Corporate Outstation Cab Pune"],
    ["Wedding Outstation Cab Pune", "Online Outstation Cab Pune"],
    ["Best Outstation Cab Service Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Outstation Cab Service in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs  provides dependable and comfortable outstation cab services from Pune — perfect for long-distance travel, leisure trips, and business journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Benefit from clear and affordable pricing for outstation trips from Pune, with no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or Tempo Travellers to suit your group size, luggage, and travel preferences."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers are familiar with routes from Pune to various cities and tourist destinations, ensuring a safe and punctual journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer pickups from anywhere in Pune and drop-offs at any location at your outstation destination, providing complete convenience."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability throughout your outstation travel."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route planning, and any travel-related queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune outstation cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]






























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer outstation cab services in Pune?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable outstation cab services from Pune to popular cities, tourist spots, and pilgrimage destinations across Maharashtra and India.',
  },
  {
    question: 'How can I book an outstation cab in Pune with Sai Trupti Cabs?',
    answer: 'You can easily book an outstation cab in Pune through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation and assistance.',
  },
  {
    question: 'What types of cabs are available for Pune outstation trips?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers for solo travelers, families, and groups.',
  },
  {
    question: 'Are the drivers experienced for Pune outstation cab journeys?',
    answer: 'Yes, all our drivers are professional, courteous, and well-experienced in long-distance travel, ensuring a safe and comfortable journey from Pune.',
  },
  {
    question: 'Can I hire an outstation cab in Pune for family, corporate, or group travel?',
    answer: 'Certainly. Our outstation cab services in Pune cater to family vacations, corporate trips, group tours, pilgrimages, and airport transfers.',
  },
  {
    question: 'Is the outstation cab service in Pune available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 outstation cab services in Pune, allowing you to schedule your ride anytime for maximum convenience and flexibility.',
  },
  {
    question: 'What are the fares for Pune outstation cab services?',
    answer: 'Outstation cab fares from Pune start from approximately ₹1,200 for sedans and ₹1,800–₹3,500 for SUVs and larger vehicles, depending on the distance, vehicle type, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for outstation cab bookings in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune outstation cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict safety and hygiene measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during outstation cab trips from Pune?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your Pune outstation cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Booking an outstation cab from Pune with Sai Trupti Cabs was effortless. The car was clean and comfortable, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Deshmukh',
    feedback: 'Excellent outstation cab service from Pune. Smooth ride, courteous driver, and great support from the team throughout the journey.',
    rating: 5,
  },
];















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Outstation Cab Service in Pune",
  "image": "https://saitrupticabs.com/assets/images/pune-outstation-cab-service.jpg",
  "description": "Book reliable outstation cab services in Pune with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation journeys. Affordable online booking available 24x7.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1450"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/outstation-cab-service-pune"
  }
};







  return (
    <div>
      <Helmet>
  <title>Outstation Cab Service in Pune | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book reliable outstation cab services in Pune with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation journeys. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Outstation Cab Service in Pune, Pune Outstation Taxi Service, Pune Outstation Car Hire, AC Outstation Cab Pune, Non AC Outstation Cab Pune, Luxury Outstation Cab Pune, Innova Outstation Cab Pune, Ertiga Outstation Cab Pune, Affordable Outstation Cab Pune, Pune One Way Outstation Cab, Pune Drop Cab Service, Corporate Outstation Cab Pune, Wedding Outstation Cab Pune, Online Outstation Cab Pune, Best Outstation Cab Service Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Outstationcabserviceinpune;